import API from "../index";

export const loginService = async (credentials) => {
  return API.post("/user/login", credentials);
};

export const registerService = async (credentials) => {
  return API.post("/user/register", credentials);
};

export const verifyOtpService = async (credentials) => {
  return API.post("/user/verify-otp", credentials);
};
